import { sortWorkspaceByLastUsedDesc } from './sortWorkspaceByLastUsedDesc';

export const getLastUsedWorkspace = <I extends { lastUsed: string }>(workspaces: I[]): I =>
  sortWorkspaceByLastUsedDesc(workspaces)[0];
